import CookiesMgr from 'coreClasses/cookies/CookiesMgr';

import {isServer} from 'coreUtils/utils';

export const RISKIFIED_SID_COOKIE_NAME = 'sid';

/**
 * Reads the SFCC session id from the `sid` cookie.
 *
 * Both the native Riskified Beacon (`useLoadRiskifiedScript`) and the Payrails
 * Fraud SDK send this id to Riskified as the `sid` query parameter, so the
 * browser session matches the server-side Riskified `cart_token`
 * (`session.sessionID`).
 *
 * @returns the SFCC session id when the cookie is available
 */
export const getRiskifiedSessionId = (): string | undefined => {
	if (isServer) {
		return undefined;
	}

	return CookiesMgr.getCookie(RISKIFIED_SID_COOKIE_NAME).getValue();
};
